<template>
  <o-section
    :title="label || schema.verbose_name"
    not-closable
    :level="level + 1"
    body-classes="p-0"
  >
    <o-item-editable-table
      v-model="items"
      :default-new-value="newChild"
      :form-state="formState"
      :item-name="schema.verbose_name"
      use-active-end-date-null-only
      @change="changed"
    >
      <template slot="o-headers">
        <th v-if="canSee(schema, 'code_pickup_item')">
          {{ schema.fields.code_pickup_item.label }}
        </th>
        <th v-if="canSee(schema, 'quantity')">
          {{ schema.fields.quantity.label }}
        </th>
      </template>
      <template slot="o-body" slot-scope="{ item, index }">
        <td v-if="canSee(schema, 'code_pickup_item')">
          <o-widget-wrapper
            :schema="schema"
            name="code_pickup_item"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-select
              v-model="items[index].code_pickup_item"
              :items="optionCodePickupItemItems"
              text-field="description"
              value-field="id"
              sort-field="description"
              :form-state="formState"
              :loading="optionCodePickupItemWorking"
              name="code_pickup_item"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              nolabel
              v-bind="schema.fields.code_pickup_item"
              allow-add
              store-name="CodePickupItem"
              add-title="Create New"
            >
              <template
                slot="form"
                slot-scope="{ item, formState, serverErrors }"
              >
                <code-pickup-item-form
                  :item="item"
                  :form-state="formState"
                  :server-errors="serverErrors"
                  in-modal
                ></code-pickup-item-form>
              </template>
            </o-select>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'quantity')">
          <o-widget-wrapper
            :schema="schema"
            name="quantity"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-text-field
              v-model="items[index].quantity"
              :form-state="formState"
              name="quantity"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              nolabel
              v-bind="schema.fields.quantity"
            ></o-text-field>
          </o-widget-wrapper>
        </td>
      </template>
    </o-item-editable-table>
  </o-section>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import schema from "../../schema/index";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import { CreateDefaultItem } from "../../../vue-ocom/schema/schema_utils";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
} from "../../../vue-ocom/mixins";
import OItemEditableTable from "../../../vue-ocom/components/table/OItemEditableTable";
import OSection from "../../../vue-ocom/components/layout/OSection";

export default {
  name: "JobPickupItemFormTable",
  mixins: [
    CreateFormStateMixin("validators"),
    CreateGroupPermissionMixin("JobPickupItem"),
    CreateCodeTableFetchMixin(["CodePickupItem"]),
  ],
  components: { OItemEditableTable, OSection },
  model: {
    prop: "items",
    event: "changed",
  },
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    label: { type: String, default: null },
    validators: { type: Object, default: () => null },
    level: { type: Number, default: 0 },
  },
  data: function () {
    return {
      schemaModel: cleanUpModel(
        schema.JobPickupItem,
        {}
      ) /*Use this.schema instead */,
      newChild: CreateDefaultItem(schema.JobPickupItem),
    };
  },
  methods: {
    changed() {
      if (this.validator) {
        this.validator.$touch();
      }

      if (this.formState) this.formState.dirty = true;

      this.$emit("changed", this.items);
    },
  },
  computed: {},
  created() {
    // this.loadCodeTables()
  },
};
</script>
